import {
  SET_INVALID_FORM_STATE,
  SHOW_FORM_ERRORS,
  HIDE_FORM_ERRORS
} from "./mutations.type";


const state = {
  showAllErrors: false,
  invalidForm: false,
  errorMessage: 'Form has invalid data! Please, Check the form!'
};

const getters = {
  showAllErrors(state) {
    return state.showAllErrors;
  },
  invalidForm(state) {
    return state.invalidForm;
  },
  errorMessage(state) {
    return state.errorMessage;
  }
};


const mutations = {
  [SET_INVALID_FORM_STATE](state, {isInvalid, errorMessage}) {
    state.invalidForm = isInvalid;
    if(errorMessage) state.errorMessage = errorMessage;
    if(!isInvalid) state.showAllErrors = false;
  },
  [SHOW_FORM_ERRORS](state) {
    state.showAllErrors = true;
  },
  [HIDE_FORM_ERRORS](state) {
    state.showAllErrors = false;
    state.invalidForm = false;
    state.errorMessage = 'Form has invalid data! Please, Check the form!';
  }
};

export default {
  state,
  getters,
  mutations
};
